import * as React from "react";
import { IProps } from "./types";

import { ErrorMessage, Input } from "../../atoms";
import { styled } from "../../../globalStyles";
import { textPrimary, textSecondary } from '@typo/color.module.css';


export const TextField = styled.div`
  margin-bottom: ${props => props.theme.spacing.fieldSpacer};
  position: relative;
  padding: 1rem;
`;
TextField.displayName = "S.MaccaronTextField";

export const ErrorMessages = styled.div`
  position: absolute;
  top: 100%;
`;

export const HelpText = styled.span`
  color: ${props => props.theme.input.labelColor};
  font-size: 1rem;
`;

export const MaccaronTextField: React.FC<IProps> = ({
  errors,
  helpText,
  ...rest
}: IProps) => {
  const hasErrors = !!(errors && errors.length);
  return (
    <>
      <TextField>
        <Input
          className={[textPrimary].join(' ')}
          error={hasErrors}
          {...rest}
        />
        <ErrorMessages>
          <ErrorMessage errors={errors} />
          {helpText && <HelpText>{helpText}</HelpText>}
        </ErrorMessages>
      </TextField>
    </>
  );
};
